import React from "react";
export function Guarantee() {
  return <div className="gar" data-id="element-74" data-mp="1qac8bvxzmkvr">
      <div className="seal" data-id="element-75" data-mp="1o3ne23a6eqyf">
        <div data-id="element-76" data-mp="1o4eyqj28j49x">
          <b data-id="element-77" data-mp="1o2lsh4vjam2g">7</b>
          <small data-id="element-78" data-mp="1o33smclbhkfn">DIAS</small>
        </div>
      </div>
      <div data-id="element-79" data-mp="223y5b7fee7k4">
        <p className="gk" data-id="element-80" data-mp="223og3m26g4fh">Garantia total de satisfação</p>
        <h3 className="gt" data-id="element-81" data-mp="22125tenwjatk">Teste por 7 dias sem risco</h3>
        <p className="gd" data-id="element-82" data-mp="1x5mw8ywxg12y">
          Você tem <strong data-id="element-83" data-mp="1x2ijhd5ebx0o">7 dias completos</strong> para baixar, imprimir e aplicar as fichas com seus pacientes. Se
          sentir que a coleção não é para você, é só pedir o reembolso.
        </p>
        <span className="gb" data-id="element-84" data-mp="14dl2regu28a1">✦ Compra segura · Acesso imediato · Sem risco</span>
      </div>
    </div>;
}